import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if (control.get('novaSenha')?.value === control.get('confirmarNovaSenha')?.value) {

        return null;

    } else {

        return { passwordMismatch: true };
    }

};